import { forwardRef, useEffect, useRef } from "react";
import { Tab as MuiTab, type TabProps as MuiTabProps } from "@mui/material";

export type TabProps = Omit<MuiTabProps, "label"> & {
  label?: React.ReactNode;
  onLabelWidthChange?: (width: number) => void;
};

export const Tab = forwardRef<HTMLDivElement, TabProps>((props, ref) => {
  const { label, onLabelWidthChange, ...rest } = props;
  const labelRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (labelRef.current && onLabelWidthChange) {
      const resizeObserver = new ResizeObserver((entries) => {
        const width = entries[0].contentRect.width;
        onLabelWidthChange(width);
      });

      resizeObserver.observe(labelRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [onLabelWidthChange]);

  return (
    <MuiTab
      ref={ref}
      label={
        label ? (
          <span ref={labelRef} style={{ display: "inline-block" }}>
            {label}
          </span>
        ) : undefined
      }
      {...rest}
    />
  );
});

Tab.displayName = "Tab";
